import React from 'react';
import { string } from 'prop-types';

import classnames from 'classnames';

import { BuildIcon } from '../utils';

const namespace = 'ui-search-icon ui-search-icon--color-silver';
const ICON_ID = 'color_2450303';

const gradientId = `paint0_linear_${ICON_ID}`;

const IconColorSilver = (props) => (
  <BuildIcon
    {...props}
    className={classnames(namespace, props.className)}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    iconId={ICON_ID}
  >
    <path
      d="M24.2324 12.3691C24.2324 18.9966 18.8598 24.3691 12.2324 24.3691C5.605 24.3691 0.232422 18.9966 0.232422 12.3691C0.232422 5.74172 5.605 0.369141 12.2324 0.369141C18.8598 0.369141 24.2324 5.74172 24.2324 12.3691Z"
      fill="#5D5D5D"
      style={{ mixBlendMode: 'hard-light' }}
    />
    <path
      d="M24.2324 12.3691C24.2324 18.9966 18.8598 24.3691 12.2324 24.3691C5.605 24.3691 0.232422 18.9966 0.232422 12.3691C0.232422 5.74172 5.605 0.369141 12.2324 0.369141C18.8598 0.369141 24.2324 5.74172 24.2324 12.3691Z"
      fill={`url(#${gradientId})`}
      style={{ mixBlendMode: 'hard-light' }}
    />
    <defs>
      <linearGradient
        id={gradientId}
        x1="-3.88188"
        y1="0.36914"
        x2="22.2936"
        y2="26.5446"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="0.275556" stopColor="#676666" />
        <stop offset="0.548313" stopColor="#C9C9C9" />
        <stop offset="0.80124" stopColor="#676666" />
        <stop offset="1" />
      </linearGradient>
    </defs>
  </BuildIcon>
);

IconColorSilver.propTypes = {
  className: string,
};

export default IconColorSilver;
